import {
  CreateUpdateMenu,
  Menu,
  MenuItem,
  CreateUpdateMenuItem,
} from "@/types/breeze/Menu";
import { BaseService } from "../BaseService";

export class MenuService extends BaseService {
  public async getMyMenu(): Promise<Menu | null> {
    return this.getRequest("/menus/my");
  }

  public async getAllMenus(): Promise<Menu[]> {
    return this.getRequest("/menus");
  }

  public async getMenu(menuId: number): Promise<Menu> {
    return this.getRequest(`/menus/${menuId}`);
  }

  public async createMenu(menu: CreateUpdateMenu): Promise<Menu> {
    return this.postRequest("/menus", menu, "Menu created");
  }

  public async updateMenu(
    menuId: number,
    menu: CreateUpdateMenu,
  ): Promise<Menu> {
    return this.putRequest(`/menus/${menuId}`, menu, "Menu updated");
  }

  public async createMenuItem(
    menuId: number,
    menuItem: CreateUpdateMenuItem,
  ): Promise<MenuItem> {
    return this.postRequest(
      `/menus/${menuId}/items`,
      menuItem,
      "Menu item created",
    );
  }

  public async updateMenuItem(
    menuId: number,
    itemId: number,
    updates: CreateUpdateMenuItem,
  ): Promise<MenuItem> {
    return this.putRequest(
      `/menus/${menuId}/items/${itemId}`,
      updates,
      "Menu item updated",
    );
  }

  public async deleteMenu(menuId: number): Promise<void> {
    return this.deleteRequest(`/menus/${menuId}`, "Menu deleted");
  }

  public async deleteMenuItem(menuId: number, id: number): Promise<void> {
    return this.deleteRequest(
      `/menus/${menuId}/items/${id}`,
      "Menu item deleted",
    );
  }

  public async reorderMenus(
    updates: { menu_id: number; sort_order: number }[],
  ): Promise<void> {
    return this.putRequest(`/menus/reorder`, updates, "Menus reordered");
  }

  public async reorderMenuItems(
    menuId: number,
    updates: {
      item_id: number;
      sort_order: number;
      parent_id: number | null;
    }[],
  ): Promise<void> {
    return this.putRequest(
      `/menus/${menuId}/items/reorder`,
      updates,
      "Menu items reordered",
    );
  }
}

export const menuService = new MenuService();
